module.exports = __webpack_public_path__ + "static/media/OVS.07c1227b.svg";